import { Button, Card } from "flowbite-react";
import React, { useContext } from "react";
import { useState } from "react";
import MyModal from "./MyModal";
import { AiOutlinePlus, AiOutlineArrowDown } from "react-icons/ai";
import { BsInfoLg } from "react-icons/bs";
import { PDFDownloadLink } from "@react-pdf/renderer";
import PDFdynamic from "./PDFdynamic/PDFdynamic";
import DownloadInfoModal from "./DownloadInfoModal";
import { AuthContext } from "./shared/AuthProvider";

const Home = () => {
  const { buyer } = useContext(AuthContext);
  const [show, setShow] = useState(false);
  const [downloadInfoModal, setDownloadInfoModal] = useState(false);
  const [allData, setAllData] = useState([]);

  const totalPrice = allData
    .map((item) => item.totalPrice)
    .reduce((previousValue, currentValue) => previousValue + currentValue, 0);

  return (
    <div className="p-5">
      <div className="mb-4 border border-gray-200 rounded-lg ">
        <h3 className="text-lg font-bold">Client Info</h3>
        <div className="text-left p-5 text-sm">
          <p>
            <span className="font-normal">Client Name</span>: {buyer?.buyerName}
          </p>
          <p>
            {" "}
            <span className="">Address or Phone: </span> {buyer?.address}
          </p>
          <p>
            {" "}
            <span className="">Discount:</span> {buyer?.discount}
          </p>
          <p>
            {" "}
            <span className="">Previous Due:</span> {buyer?.previousDue}
          </p>
        </div>
      </div>
      {allData.length > 0 ? (
        allData?.map((product, i) => (
          <Card
            key={i}
            className="mb-4 text-left bg-gradient-to-tr from-[#7fc9a4] via-[#91e295] to-[#b2f484] shadow-lg duration-300 hover:-translate-y-2  hover:translate-x-2"
          >
            <div className="">
              <div>
                <h2>
                  <span className="">Name:</span> {product.desc}
                </h2>
                <p>Quantity: {product.qty}</p>
              </div>
              <div>
                <p>Unit Price: {product.rate}</p>
                <p>
                  Total price: <strong>{product.totalPrice}</strong>
                </p>
              </div>
            </div>
          </Card>
        ))
      ) : (
        <div className="text-center font-semibold text-3xl mt-10">
          <h2>No Product Added Yet</h2>
        </div>
      )}

      <MyModal
        data={show}
        dataFn={setShow}
        allData={allData}
        setAllData={setAllData}
      />
      <div className="flex flex-col mt-5 fixed top-[43%] right-1">
        {/* Add Product Button */}
        <Button
          className="rounded-full bg-gradient-to-r mr-1 from-cyan-500 to-blue-500 text-center text-white mb-2"
          onClick={() => setShow(!show)}
        >
          <AiOutlinePlus className="font-bold text-3xl" />
        </Button>

        {/* Bill To info  */}
        <Button
          className="rounded-full bg-gradient-to-r mr-1 from-cyan-500 to-blue-500 text-center text-white mb-2"
          onClick={() => setDownloadInfoModal(!downloadInfoModal)}
        >
          <BsInfoLg className="font-bold text-3xl" />
        </Button>
        <DownloadInfoModal
          downloadInfoModal={downloadInfoModal}
          setDownloadInfoModal={setDownloadInfoModal}
        />

        {/* Pdf download link */}
        <PDFDownloadLink
          fileName={buyer.buyerName}
          document={<PDFdynamic allData={allData} buyer={buyer} />}
        >
          {({ loading }) =>
            loading ? (
              <button>Loading Document...</button>
            ) : (
              <Button className="rounded-full bg-gradient-to-r mr-1 from-cyan-500 to-blue-500 text-center text-white text-lg mb-2">
                <AiOutlineArrowDown className="font-bold text-3xl" />
              </Button>
            )
          }
        </PDFDownloadLink>
      </div>
      <div>
        <h2 className="text-2xl font-bold mt-5">Total = {totalPrice}</h2>
      </div>
      {/* Pdf start */}
      {/* <div className='flex justify-center p-5'>
                <PDFdynamic allData={allData} />
            </div> */}
    </div>
  );
};

export default Home;
